function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 5.91941C8.12 5.91941 7 7.02682 7 8.39132C7 9.75581 8.12 10.8632 9.5 10.8632C10.88 10.8632 12 9.75581 12 8.39132C12 7.02682 10.88 5.91941 9.5 5.91941ZM18 0.975586H2C0.9 0.975586 0 1.86547 0 2.95311V14.8183C0 15.9059 0.9 16.7958 2 16.7958H18C19.1 16.7958 20 15.9059 20 14.8183V2.95311C20 1.86547 19.1 0.975586 18 0.975586ZM14.79 15.0259L11.88 12.1486C11.19 12.5837 10.37 12.8408 9.49 12.8408C7.01 12.8408 5 10.8533 5 8.39132C5 5.92929 7.01 3.94188 9.5 3.94188C11.99 3.94188 14 5.92929 14 8.39132C14 9.26143 13.74 10.0623 13.3 10.7545L16.21 13.6219L14.79 15.0259Z"
});

var SvgIconFileSearch = function SvgIconFileSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFileSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconFileSearch.bfe80cfb.svg";
export { ForwardRef as ReactComponent };